"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var get_auth_header_1 = require("@wix/wix-vod-shared/dist/src/common/utils/get-auth-header");
var settings_1 = require("@wix/wix-vod-shared/dist/src/common/settings/settings");
exports.catalogServiceConfig = {
    baseURL: settings_1.hosts.catalog,
    withCredentials: true,
    xsrfHeaderName: null,
    xsrfCookieName: null,
    getHeaders: get_auth_header_1.getAuthHeader,
};
exports.publicCatalogServiceConfig = {
    baseURL: settings_1.hosts.publicCatalog,
    withCredentials: true,
    getHeaders: get_auth_header_1.getAuthHeader,
};
//# sourceMappingURL=catalog-service.js.map